var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-page"},[_c('v-container',[_c('page-not-found',{staticClass:"mx-auto mt-5 mt-md-15"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }